<template>
  <div v-if="tiles">
    <h2 class="mb-5">Moodboard</h2>
    <v-select
      :items="dropdownCategories"
      v-model="filters"
      @change="changeFilter"
    ></v-select>

    <div ref="iso" :id="name" v-images-loaded:on.progress="layout">
      <div
        class="iso-item"
        v-for="card in filteredTiles"
        :key="card.el"
        :style="{ width: card.width }"
      >
        <div class="showcard">
          <div class="showcard__inner" v-if="card.type == 'Word'">
            <div class="showcard__inner__text">
              <h2 :style="{ fontSize: card.size }">
                {{ card.title }}
              </h2>
            </div>
          </div>
          <div
            class="showcard__inner"
            :style="{ backgroundImage: `url(${card.src})` }"
            v-if="card.type == 'Image'"
          ></div>
          <div class="showcard__count">
            {{ card.count }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Isotope } from "@/vendor";
import imagesLoaded from "vue-images-loaded";

export default {
  name: "TilesMoodboard",

  data() {
    return {
      iso: null,
      intervalId: null,
      dropdownCategories: [
        "All",
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
        "Word",
      ],
      filters: "All",
    };
  },
  props: {
    tiles: {
      type: Array,
      default: null,
    },
    name: String,
  },
  directives: {
    imagesLoaded,
  },
  watch: {
    tiles(val) {
      if (val) {
        this.init();
      }
    },
    filteredTiles() {
      this.$nextTick(() => {
        this.initIso();
        this.layout();
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  computed: {
    filteredTiles() {
      if (this.filters == "All") {
        return this.tiles;
      } else {
        return this.tiles.filter((item) => item.category === this.filters);
      }
    },
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      let isoEl = document.getElementById(`${this.name}`);
      if (this.tiles && isoEl) {
        this.ready = true;
        this.$nextTick(() => {
          clearInterval(this.intervalId);
          this.intervalId = null;
          this.initIso();
          this.layout();
        });
      }
    },
    initIso() {
      delete this.iso;
      this.iso = null;
      console.log("iso does not exist");
      let isoEl = document.getElementById(`${this.name}`);
      this.iso = new Isotope(isoEl, {
        itemSelector: ".iso-item",
        layoutMode: "packery",
        transitionDuration: 0,
        hiddenStyle: {
          opacity: 0,
        },
        visibleStyle: {
          opacity: 1,
        },
      });
      this.layout();
    },
    layout() {
      if (this.iso) {
        this.iso.layout();
      }
    },
    changeFilter(val) {
      this.filters = val;
    },
  },
};
</script>
